export const notEmpty = (value, message) => {
  if (!value || value.trim().length === 0) {
    return message;
  }
  return null;
};

export const hasErrors = function hasErrors(errors) {
  return Object
    .entries(errors)
    .some(([key, value]) => {
      if (value && typeof value === 'object') {
        return hasErrors(errors[key]);
      }
      return value !== null;
    });
};
